// script.js (torusknot index.html) ~sdg
'use strict'
console.time('LoadTime')
import * as THREE from 'three'
// Styles
import './normalize.css'
import './style.css'
import { MeshBasicMaterial, MeshToonMaterial } from 'three'
// Canvas
const canvas = document.querySelector('canvas.webgl')
// Scene
const scene = new THREE.Scene()
/**
 * Axes Helper
 */
//const axesHelper = new THREE.AxesHelper(1)
//scene.add(axesHelper)
/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})
/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
scene.add(camera)
/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight( 0xffffff, 0.5 )
const pointLight = new THREE.PointLight(0xffffff, 0.5)
pointLight.position.x = 2
pointLight.position.y = 3
pointLight.position.z = 4
scene.add(ambientLight, pointLight)
/** 
 * Controls
 */
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
//const controls = new OrbitControls(camera, canvas)
//controls.enableDamping = true
// Debug
import * as dat from 'lil-gui'
const gui = new dat.GUI({ width: 200 })
gui.close()
gui.hide()
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
/**
 * Objects
 */
const textureLoader = new THREE.TextureLoader()
// MeshToonMaterial
const gradientTexture = textureLoader.load('./textures/gradients/5.jpg')
gradientTexture.minFilter = THREE.NearestFilter
gradientTexture.magFilter = THREE.NearestFilter
gradientTexture.generateMipmaps = false
const toonMaterial = new MeshToonMaterial({
  gradientMap: gradientTexture,
  color: 0xffd1b3 // peach
})
const torusKnotGeometry = new THREE.TorusKnotGeometry( 0.5, 0.22, 100, 16, 2, 3 )
const toon = new THREE.Mesh(torusKnotGeometry, toonMaterial)
toon.position.set(-0.5, 1, -2)
// Mesh StandardMaterial
const standardMaterial = new THREE.MeshStandardMaterial({
  metalness: 0.45,
  roughness: 0.3,
  color: 0xffa64d, // orange
})
const standard = new THREE.Mesh(
  new THREE.TorusKnotGeometry(0.4, 0.1, 25, 16, 4, 3),
  standardMaterial
)
standard.position.set(0, -0.5, 0.5)
scene.add(toon, standard)
/**
 * Animate
 */
const clock = new THREE.Clock()
const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()
  // Update controls
  //controls.update()

  // Update torusKnot
  toon.rotation.x = 0.25 * elapsedTime
  toon.rotation.y = 0.25 * elapsedTime

  standard.rotation.x = -0.3 * elapsedTime
  standard.rotation.y = -0.3 * elapsedTime

  // Render
  renderer.render(scene, camera)
  window.requestAnimationFrame(animate)
}
animate()
console.timeEnd('LoadTime')
// EOF script.js (torusknot index.html) ~sdg